import React from 'react';
import { palette } from '../../styles/theme';

export function AddUserSVG ({ customStroke = palette.secondary[600], className = '', selected = false, size = 24 }) {
    return (
        <span className={className}>
            <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M15 19C15 16.79 12.314 15 9 15C5.686 15 3 16.79 3 19M19 16V13M19 13V10M19 13H16M19 13H22M9 12C7.93913 12 6.92172 11.5786 6.17157 10.8284C5.42143 10.0783 5 9.06087 5 8C5 6.93913 5.42143 5.92172 6.17157 5.17157C6.92172 4.42143 7.93913 4 9 4C10.0609 4 11.0783 4.42143 11.8284 5.17157C12.5786 5.92172 13 6.93913 13 8C13 9.06087 12.5786 10.0783 11.8284 10.8284C11.0783 11.5786 10.0609 12 9 12Z" stroke={customStroke} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
        </span>
    );
}
